import React from 'react';
import Layout from './Layout';
import { sendBlueMail } from '../firebase/firebase.utils';
import { WHATSAPP_URL } from './Encabezado';

const TELEFONO = '+527712438160';
const WHATSAPP_INFO = WHATSAPP_URL + '?text=' + encodeURIComponent('Hola, ¿me podrías brindar información del servicio de internet?');

const TEMAS = [
    { icono: 'fas fa-wifi', titulo: 'Contratar internet', texto: '¿Quieres contratar alguno de nuestros planes de internet?', href: WHATSAPP_INFO, accion: 'Escríbenos por WhatsApp' },
    { icono: 'fas fa-headset', titulo: 'Soporte técnico (CAT)', texto: '¿Tienes algún problema técnico y buscas ayuda?', href: `tel:${TELEFONO}`, accion: 'Llama al (771) 243-8160' },
    { icono: 'fas fa-envelope', titulo: 'Otras dudas', texto: 'Pagos, facturación, documentos o cualquier otro tema.', href: 'mailto:asistencia@reditmex.com', accion: 'asistencia@reditmex.com' },
];

const REDES = [
    { href: 'https://www.facebook.com/itmexoficial', icono: 'fab fa-facebook-f', nombre: 'Facebook' },
    { href: 'https://www.instagram.com/reditmex', icono: 'fab fa-instagram', nombre: 'Instagram' },
    { href: 'https://www.youtube.com/channel/UC6Sirelw0bYpaT4VktsK19A', icono: 'fab fa-youtube', nombre: 'YouTube' },
    { href: 'https://open.spotify.com/show/56dQAu73j4a0QaLRO44oa7', icono: 'fab fa-spotify', nombre: 'Spotify' },
    { href: 'https://podcasts.apple.com/mx/podcast/internet-en-pandemia/id1552637394', icono: 'fas fa-podcast', nombre: 'Apple Podcasts' },
];

// Anti-spam (sin backend propio, el correo se encola desde el navegador):
// - "web" es un campo trampa invisible para personas; los bots lo llenan.
// - Un envío antes de TIEMPO_MINIMO_MS desde que se abrió la página no lo hace una persona.
// En ambos casos se finge éxito para que el bot no aprenda a esquivar el filtro.
const TIEMPO_MINIMO_MS = 3000;
const MENSAJE_MINIMO = 10;
const soloDigitos = (texto) => texto.replace(/\D/g, '');

const CAMPOS = [
    { id: 'contactName', label: 'Nombre completo', type: 'text', placeholder: 'Nombre y apellidos', autoComplete: 'name' },
    { id: 'contactEmail', label: 'Email', type: 'email', placeholder: 'hola@correo.com', ancho: 'mitad', autoComplete: 'email' },
    { id: 'contactPhone', label: 'Teléfono', type: 'tel', placeholder: '7711234567', ancho: 'mitad', autoComplete: 'tel' },
    { id: 'contactSubject', label: 'Asunto', type: 'text', placeholder: 'Duda o comentario' },
];

class Contacto extends React.Component {
    abiertoEn = Date.now();

    state = {
        web: '',
        camposInvalidos: [],
        loadingMail: false,
        successMail: false,
        errorMail: null,
        errorMail_code: null,
        errorMail_message: null,
        contactName: '',
        contactEmail: '',
        contactPhone: '',
        contactSubject: '',
        contactMensaje: ''
    }

    onChangeCampo = (e) => {
        this.setState({ [e.target.name]: e.target.value })
    }

    isValidEmail = (email) => {
        return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
    }

    onClickEnviar = async (e) => {
        e.preventDefault()
        const { contactName, contactEmail, contactPhone, contactSubject, contactMensaje, web } = this.state

        if (web !== '' || Date.now() - this.abiertoEn < TIEMPO_MINIMO_MS) {
            this.fingirEnvio()
            return
        }

        const campos = { contactName, contactEmail, contactPhone, contactSubject, contactMensaje }
        const vacios = Object.keys(campos).filter(c => campos[c].trim() === '')
        if (vacios.length) {
            this.setState({ errorMail: true, camposInvalidos: vacios, errorMail_code: "Campos vacíos", errorMail_message: "Faltan llenar todos los campos." })
            return
        }
        if (!this.isValidEmail(contactEmail.trim())) {
            this.setState({ errorMail: true, camposInvalidos: ['contactEmail'], errorMail_code: "Email inválido", errorMail_message: "Ingresa un correo electrónico válido." })
            return
        }
        const digitos = soloDigitos(contactPhone)
        if (digitos.length < 10 || digitos.length > 13) {
            this.setState({ errorMail: true, camposInvalidos: ['contactPhone'], errorMail_code: "Teléfono inválido", errorMail_message: "Ingresa un teléfono de 10 dígitos." })
            return
        }
        if (contactMensaje.trim().length < MENSAJE_MINIMO) {
            this.setState({ errorMail: true, camposInvalidos: ['contactMensaje'], errorMail_code: "Mensaje muy corto", errorMail_message: "Cuéntanos un poco más sobre lo que necesitas." })
            return
        }
        this.setState({ loadingMail: true, errorMail: false, camposInvalidos: [] }, async () => {
            const response = await sendBlueMail({
                nombre: contactName.trim(),
                email: contactEmail.trim(),
                telefono: contactPhone.trim(),
                asunto: contactSubject.trim(),
                mensaje: contactMensaje.trim(),
            })
            if (response.success) {
                this.setState({
                    loadingMail: false,
                    successMail: true,
                    contactName: '',
                                contactEmail: '',
                    contactPhone: '',
                    contactSubject: '',
                    contactMensaje: ''
                })
                setTimeout(() => this.setState({ successMail: false }), 5000)
            } else {
                this.setState({ loadingMail: false, errorMail: response.error, errorMail_code: response.error_code, errorMail_message: response.error_message })
            }
        })
    }

    // Mismo efecto visual que un envío real, sin mandar nada
    fingirEnvio = () => {
        this.setState({ loadingMail: true, errorMail: false })
        setTimeout(() => {
            this.setState({ loadingMail: false, successMail: true, web: '' })
            setTimeout(() => this.setState({ successMail: false }), 5000)
        }, 800)
    }

    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
    }

    claseCampo = (campo) => 'contactoForm-input' + (this.state.errorMail && this.state.camposInvalidos.includes(campo) ? ' is-invalido' : '')

    render() {
        const { loadingMail, successMail, errorMail, errorMail_code, errorMail_message } = this.state;
        return (
            <div>
                <Layout title="Red Itmex - Contacto">
                    <section className="paginaItmex paginaItmex--hero contactoItmex">
                        {/* Hero con la ilustración del inicio */}
                        <div className="contactoHero" style={{ backgroundImage: 'radial-gradient(ellipse at center, rgba(8, 28, 72, 0.55) 0%, rgba(8, 28, 72, 0.25) 60%, rgba(8, 28, 72, 0.1) 100%), linear-gradient(to bottom, rgba(8, 28, 72, 0.6) 0%, rgba(8, 28, 72, 0.2) 100%), url(/assets/img/backgrounds/ixmiquilpan-main.jpg)' }}>
                            <span className="planesItmex-eyebrow coberturaHero-eyebrow">Contacto</span>
                            <h1 className="heroItmex-title">¿Tienes preguntas?</h1>
                            <p className="heroItmex-subtitle">Nos encantaría platicar contigo.</p>
                            <div className="heroItmex-actions">
                                <a className="heroItmex-cta" href={WHATSAPP_INFO} target="_blank" rel="noopener noreferrer">
                                    <i className="fab fa-whatsapp mr-1"></i> WhatsApp
                                    <span className="heroItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
                                </a>
                                <a className="heroItmex-cta-secondary" href={`tel:${TELEFONO}`}>
                                    <i className="fas fa-phone-alt mr-2"></i> (771) 243-8160
                                </a>
                            </div>
                        </div>

                        <div className="contactoTemas">
                            {TEMAS.map(tema => (
                                <a key={tema.titulo} className="beneficiosPaso contactoTema" href={tema.href}
                                    {...(tema.href.startsWith('http') ? { target: '_blank', rel: 'noopener noreferrer' } : {})}>
                                    <span className="beneficiosPaso-icono"><i className={tema.icono}></i></span>
                                    <h2 className="paginaItmex-tarjeta-titulo">{tema.titulo}</h2>
                                    <p className="paginaItmex-tarjeta-texto">{tema.texto}</p>
                                    <span className="planItmex-cta">
                                        {tema.accion}
                                        <span className="planItmex-cta-arrow"><i className="fas fa-arrow-right"></i></span>
                                    </span>
                                </a>
                            ))}
                        </div>

                        <div className="contactoLayout" id="formulario">
                            <div className="contactoInfo">
                                <h2 className="tituloItmex tituloItmex--chico">¡Contáctanos!</h2>
                                <p className="faqItmex-subtitulo">Nos encantaría saber cómo podemos ayudarte.</p>

                                <div className="contactoMapa">
                                    <iframe
                                        title="Ubicación de Red Itmex en Ixmiquilpan"
                                        src="https://www.google.com/maps?q=20.4851751,-99.2190059&z=17&output=embed"
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                    ></iframe>
                                </div>

                                <ul className="footerItmex-contacto contactoDatos">
                                    <li><i className="fas fa-phone-alt"></i><span><b>Llámanos</b><a href={`tel:${TELEFONO}`}>+52 (771) 243-8160</a></span></li>
                                    <li><i className="fas fa-envelope"></i><span><b>Correo</b><a href="mailto:asistencia@reditmex.com">asistencia@reditmex.com</a></span></li>
                                    <li><i className="fas fa-location-arrow"></i><span><b>Dirección</b>Av. 5 de Mayo No.1, Colonia Centro, Ixmiquilpan Hidalgo, C.P. 42300</span></li>
                                    <li><i className="fas fa-clock"></i><span><b>Horario de atención</b>Lunes a Domingo de 9:00 a 18:00</span></li>
                                </ul>

                                <div className="footerItmex-redes contactoRedes">
                                    {REDES.map(red => (
                                        <a key={red.nombre} href={red.href} target="_blank" rel="noopener noreferrer" aria-label={red.nombre}><i className={red.icono}></i></a>
                                    ))}
                                </div>
                            </div>

                            <form className="contactoForm" noValidate onSubmit={this.onClickEnviar}>
                                <h2 className="contactoForm-titulo">Manda un mensaje</h2>

                                {errorMail && (
                                    <div className="contactoForm-alerta contactoForm-alerta--error" role="alert">
                                        <i className="fas fa-exclamation-circle"></i><span><b>{errorMail_code}</b> {errorMail_message}</span>
                                    </div>
                                )}
                                {successMail && (
                                    <div className="contactoForm-alerta contactoForm-alerta--exito" role="status">
                                        <i className="far fa-check-circle"></i><span>¡Correo enviado!</span>
                                    </div>
                                )}

                                {/* Campo trampa: oculto a personas y lectores de pantalla, los bots lo llenan */}
                                <div className="contactoForm-trampa" aria-hidden="true">
                                    <label>Sitio web<input type="text" name="web" tabIndex="-1" autoComplete="off" value={this.state.web} onChange={this.onChangeCampo} /></label>
                                </div>

                                <div className="contactoForm-campos">
                                    {CAMPOS.map(campo => (
                                        <label key={campo.id} className={'contactoForm-campo' + (campo.ancho === 'mitad' ? ' contactoForm-campo--mitad' : '')}>
                                            <span>{campo.label}</span>
                                            <input type={campo.type} name={campo.id} value={this.state[campo.id]} onChange={this.onChangeCampo}
                                                className={this.claseCampo(campo.id)} placeholder={campo.placeholder} autoComplete={campo.autoComplete} required />
                                        </label>
                                    ))}
                                    <label className="contactoForm-campo">
                                        <span>Mensaje</span>
                                        <textarea name="contactMensaje" rows="5" value={this.state.contactMensaje} onChange={this.onChangeCampo}
                                            className={this.claseCampo('contactMensaje')} placeholder="¡Hola!, me gustaría saber sobre..." required />
                                    </label>
                                </div>

                                <button type="submit" className="heroItmex-cta paginaItmex-cta-oscuro contactoForm-enviar" disabled={loadingMail || successMail}>
                                    {successMail ? 'Enviado' : loadingMail ? 'Enviando…' : 'Enviar mensaje'}
                                    <span className="heroItmex-cta-arrow"><i className={successMail ? 'fas fa-check' : 'fas fa-paper-plane'}></i></span>
                                </button>
                                <p className="contactoForm-nota">Te contactaremos de vuelta lo más pronto posible. Revisa que tus datos de contacto sean correctos.</p>
                            </form>
                        </div>
                    </section>
                </Layout>
            </div>
        )
    }
};
export default Contacto;
